import {boundingBox} from './resources/constants';
import * as geoViewport from '@mapbox/geo-viewport';

/* Boot the map */
export const createMap = (styleUrl, view, opts=null) => {
    const mapEl = document.getElementById('map').getBoundingClientRect();
    const mapDim = [mapEl.height, mapEl.width];
    const newbounds = geoViewport.viewport(
        boundingBox,
        mapDim,
        0,
        20,
        512
    );
    let mapDict = {
      container: 'map',
      style: styleUrl,
      center: newbounds.center,
      zoom: newbounds.zoom,
  
    }
    if(opts){
      Object.keys(opts).forEach(k => {
        mapDict[k] = opts[k];
      })
    }
    if(view === 'detail'){
      mapDict['interactive'] = false;
    }
    const map = new mapboxgl.Map(mapDict);
    map.addControl(new mapboxgl.ScaleControl({unit: 'imperial'}));
    return map;
}

/* Initial sizing of the map */
export const fitMap = () => {
    if(window.innerWidth < 700){
      const padding = {top: 150, bottom: window.innerHeight * .4 + 10, left: 30, right: 30};
      window.fireMap.fitBounds(boundingBox, {
        padding: padding
      })
      window.fireMap.resize();
    } else {
      const padding = {top: 100, bottom: 50, left: 390, right: 50};
      window.fireMap.fitBounds(boundingBox, {
        padding: padding
      })
    }
}
